import {zonedTimeToUtc} from '@wix/table-reservations-lib/timezone'
import {addMinutes, addHours, addDays, addMonths} from 'date-fns'
import {
  Unit,
  NoticePeriod,
  SpecialHourPeriod,
} from '@wix/ambassador-table-reservations-v1-reservation-location/types'

import {
  roundUpToNearestQuarterTime,
  roundDownToNearestQuarterTime,
  MAX_MONTHS_FORWARD_SEARCH,
} from './date'

export const convertMinimumReservationNoticeToSpecialHourPeriod = (
  noticePeriod: NoticePeriod,
  timeZone?: string | null,
): SpecialHourPeriod => {
  const now = zonedTimeToUtc(new Date(), timeZone)

  const startDate = roundDownToNearestQuarterTime(now)
  const endDate = roundUpToNearestQuarterTime(addNoticePeriod(now, noticePeriod))

  return {
    comment: 'minimumReservationNotice',
    isClosed: true,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  }
}

export const convertMaximumReservationNoticeToSpecialHourPeriod = (
  noticePeriod: NoticePeriod,
  timeZone?: string | null,
): SpecialHourPeriod => {
  const now = zonedTimeToUtc(new Date(), timeZone)

  const startDate = addNoticePeriod(roundDownToNearestQuarterTime(now), noticePeriod)
  const endDate = roundUpToNearestQuarterTime(addMonths(now, MAX_MONTHS_FORWARD_SEARCH + 1))

  return {
    comment: 'maximumReservationNotice',
    isClosed: true,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  }
}

const addNoticePeriod = (date: Date, {number, unit}: NoticePeriod) => {
  if (number && unit) {
    switch (unit) {
      case Unit.MINUTES:
        return addMinutes(date, number)
      case Unit.HOURS:
        return addHours(date, number)
      case Unit.DAYS:
        return addDays(date, number)
    }
  }

  return date
}
